import { SearchBarService } from 'features/searchBar';
import SearchBarResultCategory from "enums/searchResultCategory";

/**
 * Retrieves the first search result for the given search text.
 * @param {string} searchText - The search text to query.
 * @returns {Promise<Object|null>} - A promise that resolves to the first search
 * result or null if no results are found.
 */
async function getFirstSearchResult(searchText) {
  const searchResults = await SearchBarService.fetchSearchResults(searchText);
  if (!searchResults?.Results?.length) {
    return null;
  }

  return searchResults.Results[0];
}

/**
 * Redirects the user to the search results page for the specified location.
 * @param {string} searchText - The location value to be used in the search results page URL.
 */
const redirectToSearchCommunityResults = async (searchText) => {
  const result = await getFirstSearchResult(searchText);
  const locationUrl = result?.LocationUrl?.trim();

  const locationCategoryId = Number(SearchBarResultCategory.Location.id);
  const resultCategoryType = Number(result?.SearchBarResultCategoryType);
  const isLocationCategory = resultCategoryType === locationCategoryId;

  if (!locationUrl || !isLocationCategory) {
    return;
  }

  window.open(locationUrl, '_blank');
};

export default redirectToSearchCommunityResults;
